<template>
  <div class="login-page" :style="loginPageStyle">
    <div class="login-content">
      <div class="brand-logo">
        <img src="../assets/logo1.png" style="width: 40%;" alt="logo" />
      </div>
      <h1 class="welcome-text">豫皖大区</h1>
      <h1 class="welcome-text">西门子家电<span>数据看板</span></h1>

      <div class="login-form-container">
        <el-form 
          ref="loginFormRef"
          :model="loginForm" 
          :rules="loginFormRules"
          label-width="0px"
          class="login-form"
        >
          <el-form-item prop="account" class="input-item">
            <el-input
              v-model="loginForm.account"
              placeholder="请输入账号..."
              clearable
              maxlength="20"
              class="custom-input"
            >
              <template #prefix>
                <span class="input-label">账号</span>
              </template>
            </el-input>
          </el-form-item>
          
          <el-form-item prop="password" class="input-item">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="***************"
              show-password
              clearable
              maxlength="20"
              class="custom-input"
            >
              <template #prefix>
                <span class="input-label">密码</span>
              </template>
            </el-input>
          </el-form-item>

          <div class="remember-account">
            <el-checkbox v-model="rememberAccount">记住账号</el-checkbox>
          </div>
          
          <el-form-item class="submit-item">
            <el-button 
              type="primary" 
              @click="onLogin" 
              :loading="loginLoading"
              class="login-btn"
              size="large"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { apiLogin, getConfig } from '../api'
import { isLoggedIn, saveLoginData } from '../utils/auth'
import homgbg from '../assets/homgbg.png'

const router = useRouter()
const loginLoading = ref(false)
const rememberAccount = ref(false)
const loginForm = ref({
  account: '',
  password: ''
})
const loginFormRef = ref()

// 登录页背景样式，默认使用本地图片
const loginPageStyle = ref({
  backgroundImage: ` url(${homgbg})`,
  backgroundSize: '100% 100%, cover',
  backgroundRepeat: 'no-repeat, no-repeat',
  backgroundPosition: 'top center, center bottom'
})

const loginFormRules = {
  account: [
    { required: true, message: '请输入账号', trigger: 'blur' },
    { min: 3, max: 20, message: '账号长度在 3 到 20 个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
  ]
}
//获取背景图片
const getBackgroundImage = async () => {
  const {data}= await getConfig({ code: 'm_loginbg' })
  if(data && data.value_pull){
    const bannerStr = data.value_pull.trim();
    if (bannerStr) {
      // 按逗号分隔，过滤空字符串
      loginPageStyle.value.backgroundImage = `url(${bannerStr.split(',').map(url => url.trim()).filter(url => url)[0]})`
    }
  }
}

onMounted(() => {
  getBackgroundImage()
  if (isLoggedIn()) {
    ElMessage.info('您已登录，正在跳转到首页...')
    router.replace('/dashboard')
  }
})

async function onLogin(){
  if (!loginFormRef.value) return
  
  try {
    await loginFormRef.value.validate()
  } catch (error) {
    ElMessage.warning('请检查表单信息')
    return
  }
  
  loginLoading.value = true
  try{
    const res = await apiLogin({ 
      account: loginForm.value.account, 
      password: loginForm.value.password 
    })
    if(res && res.data.access_token){
      saveLoginData(res.data)
      ElMessage.success('登录成功')
      router.push('/dashboard')
    } else {
      ElMessage.error('登录失败')
    }
  } catch(e){
    ElMessage.error(e?.response?.data?.message || '登录失败')
  } finally {
    loginLoading.value = false
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 64px 24px;
  box-sizing: border-box;
  background-attachment: fixed;
}

.login-content {
  width: 100%;
  max-width: 420px;
  color: #0f1b2b;
  padding: 0px 20px;
}

.welcome-text {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  margin-top: 24px;
}
.welcome-text span{
  color: #00cda3;
}

.platform-name {
  font-size: 18px;
  margin: 25px 0 36px;
}

.login-form-container {
  padding: 32px 0px 40px;
  border-radius: 32px;
}

.login-form :deep(.el-form-item) {
  margin-bottom: 24px;
}

.custom-input :deep(.el-input__wrapper) {
  border-radius: 999px;
  padding: 0 20px;
  height: 52px;
  box-shadow: inset 0 0 0 1px rgba(15, 27, 43, 0.05);
  background: #fff;
}

.custom-input :deep(.el-input__inner) {
  font-size: 16px;
  color: #0f1b2b;
}

.custom-input :deep(.el-input__inner::placeholder) {
  color: #a6adb5;
}

.custom-input :deep(.el-input__prefix) {
  display: flex;
  align-items: center;
  color: #0f1b2b;
  font-weight: 600;
  font-size: 16px;
  margin-right: 12px;
}

.remember-account {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.remember-account :deep(.el-checkbox__label) {
  color: #fff;
  font-size: 14px;
}

.submit-item {
  margin-bottom: 0;
}

.login-btn {
  color: #000;
  width: 100%;
  height: 54px;
  border-radius: 999px;
  background: linear-gradient(90deg, #00b7a7, #00cda3);
  border: none;
  font-size: 18px;
  letter-spacing: 2px;
}

.login-btn:hover {
  opacity: 0.95;
}

.login-btn:active {
  opacity: 0.9;
}

@media (max-width: 480px) {
  .login-page {
    padding: 40px 18px;
  }

  .brand-logo {
    font-size: 26px;
    margin-bottom: 24px;
  }

  .platform-name {
    margin-bottom: 28px;
  }

  .login-form-container {
    padding: 28px 0px 32px;
  }
}
</style>

